import BaseError from '../BaseError'
import { IEventService, EventHandler } from './IEventService'
import { Event, IEventPayload } from '../events/BlockEvent'


class HandlerRegistry implements IEventService {
    private readonly handlersMap: Map<Event, Array<EventHandler<IEventPayload>>>
    private readonly eventsSet: Set<Event>

    constructor(events: Iterable<Event>) {
        this.handlersMap = new Map<string, Array<EventHandler<IEventPayload>>>()
        this.eventsSet = new Set(events)
    }

    private getOrDefault(event: Event): Array<EventHandler<IEventPayload>> {
        if (!this.handlersMap.has(event))
            this.handlersMap.set(event, [])
        // @ts-ignore
        return this.handlersMap.get(event)
    }

    private isSupportedEvent(event: Event): boolean {
        return this.eventsSet.has(event)
    }

    getHandlers(event: Event): Iterable<EventHandler<IEventPayload>> {
        return this.handlersMap.get(event) || []
    }

    subscribe(event: Event, handler: EventHandler<any>): void {
        if (!this.isSupportedEvent(event))
            throw new BaseError(`Incorrect value event arg. Unknown event: ${event}`)

        let eventHandlers = this.getOrDefault(event)
        eventHandlers.push(handler)
    }

    unsubscribe(event: Event, handler: EventHandler<any>): void {
        if (!this.isSupportedEvent(event))
            throw new BaseError(`Incorrect value event arg. Unknown event: ${event}`)

        let eventHandlers = this.getOrDefault(event)
        const index = eventHandlers.indexOf(handler, 0)
        if (index <= -1)
            throw new BaseError(`Handler not found for event: ${event}`)

        eventHandlers.splice(index, 1)
    }
}

export default HandlerRegistry